import React from 'react';
import { userTypeDrop } from '../../../../../enums/userTypeEnumDrop';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../../../components/CustomTextField';
import DenyDocumentApp from "../Functionality/DenyDocumentApp";

const DenyDocumentModal = (props) => {
    const {userType, documentName, employeeName, itemName} = props;
    const {t, handle, commentText, setCommentText} = DenyDocumentApp(props);

    return (
        <CustomModal
            title={'deny'}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onConfirm={() => {
                handle();
            }}
            classNameBody="pt-2"
        >
            <div className={"row"}>
                <div className={"col-12 d-flex justify-content-center align-items-center"}>
                    <span className='modal-desc-text'>
                        {t('are_you_sure_you_want_to_deny_the_document')}
                        <strong>{' ' + documentName}</strong>
                        {' ' + t('for_the').toLowerCase()}
                        { itemName ?
                            <strong>{' ' + itemName}</strong>
                            :
                            <>
                                <strong>{' ' + t(userTypeDrop[userType])}</strong>
                                <strong>{' ' + employeeName}</strong>
                            </>
                        }

                        {'? ' + t('enter_a_comment_to_guide_the_user')}
                    </span>

                </div>
                <div className='col-sm-12 d-flex justify-content-center align-items-center mt-4'>
                    <CustomTextField id={"txt_ddm_name"}
                        length={128}
                        name={"comments"}
                        value={commentText}
                        trans={"comments"}
                        type={"text"}
                        onChange={(e) => setCommentText(e.target.value)}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default DenyDocumentModal;
